export const GENERAL_ERROR                = 1;
export const LOADING_ERROR                = 20;
export const LOGIN_ERROR                  = 100;
export const LOGOUT_ERROR                 = 110;
export const SEND_PASSWORD_RECOVERY_ERROR = 120;
export const RESET_PASSWORD_ERROR         = 130;